<template>
  <div class="h-full overflow-hidden">
    <ProductVirtualList
      class="border-b border-background-fg/5"
    >
      <template #category="item">
        <ProductListItemCategory
          :category="item.category"
        />
      </template>
      <template #product="item">
        <ProductListItemProduct
          v-on-long-press="[
            () => handleLongClickProduct(item.product),
            { delay: 500 },
          ]"
          :product="item.product"
          @click="() => handleClickProduct(item.product)"
        />
      </template>
    </ProductVirtualList>
  </div>

  <FullTillVariablePriceModal
    v-model:is-open="showVariablePriceModal"
    :product="currentProduct"
    @ok="handleSubmitVariablePriceModal"
  />

  <OrderItemDrawer ref="orderItemDrawerRef" />

  <ProductInfoModal
    v-model:is-open="showProductInfoModal"
    :product="currentProduct"
  />
</template>

<script setup lang="ts">
import type { Product } from "@/services/sharedTypes/products"
import type { VariablePriceModalPayload } from "./FullTillVariablePriceModal.vue"
import { vOnLongPress } from "@vueuse/components"
const { addItem } = useCurrentOrder()

const orderItemDrawerRef = useTemplateRef(
  "orderItemDrawerRef"
)

const showVariablePriceModal = ref(false)
const currentProduct = ref<Product | null>(null)
const handleClickProduct = async (product: Product) => {
  if (product.hasVariablePrice) {
    currentProduct.value = product
    showVariablePriceModal.value = true
  } else if (product.modifierGroupIds.length > 0) {
    if (!orderItemDrawerRef.value) return

    const { isCanceled, data: modifierPayload } =
      await orderItemDrawerRef.value.reveal({
        product,
      })
    if (isCanceled || !modifierPayload) return
    addItem({
      ...modifierPayload.params,
      product: product,
      price: product.price,
    })
  } else {
    addItem({
      product: product,
      note: null,
      price: product.price,
      modifiers: null,
      quantity: 1,
    })
  }
}

const handleSubmitVariablePriceModal = ({
  product,
  price,
}: VariablePriceModalPayload) => {
  if (price && product) {
    addItem({
      product: product,
      price: price,
      note: null,
      quantity: 1,
      modifiers: null,
    })
  }
  showVariablePriceModal.value = false
}

const showProductInfoModal = ref(false)
const handleLongClickProduct = (product: Product) => {
  currentProduct.value = product
  showProductInfoModal.value = true
}
</script>
